import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Grid, Typography, useMediaQuery } from '@material-ui/core';

// COMPONENTS
import RouterBreadcrumbs from '@/components/RouterBreadcrumbs';

// STYLES
import { Container } from './styles';

const Hero = props => {
  const {
    bgColor,
    color,
    className,
    hideBreadcrumbs,
    title,
    subtitle,
    description,
    children,
    rightContent,
  } = props;
  const downSm = useMediaQuery(({ breakpoints }) => breakpoints.down('sm'));

  return (
    <Container className={clsx(className, 'hero')} bgColor={bgColor} color={color}>
      <div className="page-content">
        {!hideBreadcrumbs && <RouterBreadcrumbs className="hero__breadcrumbs" />}
        <Grid container spacing={4}>
          <Grid className="hero__left-section" item xs={12} sm={7}>
            <div className="hero__left-content">
              {!!subtitle && <Typography className="hero__subtitle p5">{subtitle}</Typography>}
              {!!title && (
                <Typography className="hero__title" variant={downSm ? 'h2' : 'h1'} component="h1">
                  {title}
                </Typography>
              )}
              {!!description && (
                <Typography className={clsx('hero__description', downSm ? 'p3' : 'p1')}>
                  {description}
                </Typography>
              )}
              {children}
            </div>
          </Grid>
          <Grid className="hero__right-section" item xs={12} sm={5}>
            {rightContent}
          </Grid>
        </Grid>
      </div>
    </Container>
  );
};

Hero.defaultProps = {
  bgColor: '',
  color: '',
  className: '',
  hideBreadcrumbs: false,
  title: '',
  subtitle: '',
  description: '',
};

Hero.propTypes = {
  bgColor: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  hideBreadcrumbs: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  rightContent: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default Hero;
